module.exports = __webpack_public_path__ + "zvetseni-prsou_23_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_23_before.jpg
// module id = 1318
// module chunks = 0